/* import __COLOCATED_TEMPLATE__ from './conversation-sla-paused.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationSlaPaused from 'embercom/objects/inbox/renderable/conversation-sla-paused';
import LinkWithText from 'embercom/helpers/link-with-text';

interface ConversationSlaPausedPart extends RenderablePart {
  renderableData: ConversationSlaPaused;
}

interface Args {
  part: ConversationSlaPausedPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsConversationSlaPausedComponent extends Component<Signature> {
  @service declare session: Session;

  // @ts-ignore helper doesn't seem to be typed correctly
  linkWithTextHelper = LinkWithText.create(this);

  get renderableData() {
    return this.args.part.renderableData;
  }

  get teammate() {
    return this.renderableData.adminSummary;
  }

  get translationData() {
    if (this.teammate.id === this.session.teammate.id) {
      return {
        key: 'you-paused-sla',
        data: {
          sla: this.renderableData.conversationSla.label,
        },
      };
    } else {
      return {
        key: 'admin-paused-sla',
        data: {
          who: this.linkWithTextHelper.compute([
            'apps.app.admins.admin',
            this.teammate.id,
            this.teammate.name,
          ]),
          sla: this.renderableData.conversationSla.label,
        },
      };
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationSlaPaused': typeof Inbox2ConversationStreamEventPartsConversationSlaPausedComponent;
    'inbox2/conversation-stream/event-parts/conversation-sla-paused': typeof Inbox2ConversationStreamEventPartsConversationSlaPausedComponent;
  }
}
